export const isNotNullOrUndefined = <T>(obj: T | null | undefined): obj is T => obj !== undefined && obj !== null;

export const isNullOrUndefined = <T>(obj: T | null | undefined): obj is null | undefined => obj === undefined || obj === null;
